module.exports = "https://lts-static.prod-my.games/promo/lp1/img/weapon-2.7ea53b16.png";